import { useState } from "react";
import { X, Plus } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { PATIENTS } from "@/constants/testIds";
import { PREDEFINED_TAGS, TAG_COLORS, DEFAULT_TAG_COLOR, tagLabel } from "@/lib/patientConstants";

/** Selector de etiquetas configurable: predefinidas (VIP, Nuevo, etc.) +
 * posibilidad de agregar etiquetas propias. */
export default function PatientTagsSelect({ value = [], onChange, disabled }) {
  const [customTag, setCustomTag] = useState("");

  const toggleTag = (tagValue) => {
    if (disabled) return;
    if (value.includes(tagValue)) {
      onChange(value.filter((t) => t !== tagValue));
    } else {
      onChange([...value, tagValue]);
    }
  };

  const addCustomTag = () => {
    const slug = customTag.trim().toLowerCase().replace(/\s+/g, "_");
    if (!slug || value.includes(slug)) return;
    onChange([...value, slug]);
    setCustomTag("");
  };

  return (
    <div className="space-y-3">
      <div className="flex gap-2 flex-wrap">
        {PREDEFINED_TAGS.map((t) => {
          const active = value.includes(t.value);
          return (
            <button
              key={t.value}
              type="button"
              disabled={disabled}
              onClick={() => toggleTag(t.value)}
              data-testid={`${PATIENTS.tagOptionPrefix}${t.value}`}
              className={`px-3 py-1.5 rounded-full text-xs font-medium border transition-colors disabled:opacity-50 disabled:cursor-not-allowed ${
                active ? `${TAG_COLORS[t.value]} border-transparent` : "bg-white text-muted-foreground border-border hover:bg-background"
              }`}
            >
              {t.label}
            </button>
          );
        })}
      </div>

      {value.filter((t) => !PREDEFINED_TAGS.some((p) => p.value === t)).length > 0 && (
        <div className="flex gap-1.5 flex-wrap">
          {value.filter((t) => !PREDEFINED_TAGS.some((p) => p.value === t)).map((t) => (
            <Badge key={t} className={`${DEFAULT_TAG_COLOR} border-none font-normal gap-1`}>
              {tagLabel(t)}
              {!disabled && (
                <button type="button" onClick={() => toggleTag(t)} data-testid={`${PATIENTS.tagRemovePrefix}${t}`}>
                  <X className="w-3 h-3" />
                </button>
              )}
            </Badge>
          ))}
        </div>
      )}

      {!disabled && (
        <div className="flex gap-2">
          <Input
            placeholder="Agregar etiqueta personalizada..."
            value={customTag}
            onChange={(e) => setCustomTag(e.target.value)}
            onKeyDown={(e) => { if (e.key === "Enter") { e.preventDefault(); addCustomTag(); } }}
            data-testid={PATIENTS.tagCustomInput}
            className="h-8 text-sm max-w-xs"
          />
          <Button type="button" size="sm" variant="outline" onClick={addCustomTag} data-testid={PATIENTS.tagCustomAddButton}>
            <Plus className="w-3.5 h-3.5" />
          </Button>
        </div>
      )}
    </div>
  );
}
